import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
var format = require('xml-formatter');


export default props => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/atendimento/prestadorcbos', id,
            obj => {

                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Visualização Prestador Cbos',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj?.id, tamanho: 'col-lg-4' },
                                { titulo: 'Prestador', descricao: obj?.prestador?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Cbos', descricao: obj?.cbos.label, tamanho: 'col-lg-4' },
                                { titulo: 'Número RQE', descricao: obj?.numero_rqe, tamanho: 'col-lg-4' },
                                // { titulo: 'Principal', descricao: obj?.principal_sim_nao, tamanho: 'col-lg-4' },
                                { titulo: 'Data Registro', descricao: obj?.data_registro, tamanho: 'col-lg-4' },

                            ]
                        },
                    ]
                } : { titulo: 'Visualização Prestador CBOS' })

            })

    }, [id])


    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}
